import React from 'react';

// Pill marking a loan file as managed in Arive (ticket 134 P1), modelled on
// GhlBadge. With `deepLink` it adds an "Open in Arive" link next to the pill.
export default function AriveBadge({ deepLink = null }) {
  return (
    <span className="inline-flex items-center gap-1.5" data-testid="arive-badge-wrap">
      <span
        data-testid="arive-badge"
        title="Managed in Arive"
        className="inline-flex items-center text-[10px] font-bold uppercase tracking-wide px-1.5 py-0.5 rounded-full"
        style={{ background: '#ECFDF5', color: '#065F46' }}
      >
        Managed in Arive
      </span>
      {deepLink && (
        <a
          href={deepLink}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="arive-open-link"
          className="text-[11px] font-semibold underline whitespace-nowrap"
          style={{ color: '#070B5F' }}
        >
          Open in Arive
        </a>
      )}
    </span>
  );
}
